import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'xyz-shared-tag',
    imports: [CommonModule, TooltipModule],
    templateUrl: './tag.component.html',
    styleUrls: ['./tag.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TagComponent {
  @Input()
  public icon!: string;

  @Input()
  public title: string | undefined;

  @Input()
  public severity: string = '';

  @Input()
  public size: string = 'md';

  @Input()
  public square: boolean = false;

  @Input()
  public outlined: boolean = false;

  @Input()
  public dotted: boolean = false;

  @Input()
  public small: boolean = false;

  @Input()
  public iconOnly: boolean = false;

  @Input()
  public noMinWidth: boolean = false;

  @Input()
  public primeIcon!: string;

  @Input()
  public interactive: boolean = false;

  @Input()
  public align: string = 'center';

  @Input()
  public styleClass: string[] = [];
}
